var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-menu-section"},[_c('div',{staticClass:"menu-list"},_vm._l((_vm.filteredContent),function(item,i){return _c('product-menu-item',{key:`${item.section.alias}-${i}`,attrs:{"item":item,"activeSection":_vm.activeSection,"index":i}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }